<script setup>
import { useStore } from "@/core/services/store";
import { setXentralConfig } from "@/composables/useSalesChannelManagementApp";

const store = useStore();

// on hosted instances xentralConfig.data.state is populated
// server-side. Locally the OAuth state arrives only on the redirect back from
// the provider (ngrok). Because the app uses hash routing, the backend appends
// ?state=... after the hash route (…/#/…/wizard?state=…), so the param lives in
// the hash query, not window.location.search — read both.
const oAuthStateFromUrl = (() => {
  const fromSearch = new URLSearchParams(window.location.search).get("state");
  if (fromSearch) return fromSearch;
  const hash = window.location.hash || "";
  const queryIndex = hash.indexOf("?");
  return queryIndex === -1
    ? null
    : new URLSearchParams(hash.slice(queryIndex + 1)).get("state");
})();
if (oAuthStateFromUrl && !store.getters.xentralConfig?.data?.["state"]) {
  const xentralData = store.getters.xentralConfig ?? {};
  setXentralConfig({
    ...xentralData,
    data: { ...(xentralData.data ?? {}), state: oAuthStateFromUrl }
  });
}
</script>

<template>
  <router-view class="h-100" />
</template>

<style scoped lang="scss"></style>

<style lang="scss">
// Create a more xentral like look inside the iframe in xentral itself
.v-application {
  background-color: transparent !important;
}
</style>
